<div id="layout" class="theme-cyan">
  <app-leftmenu></app-leftmenu>
  <!-- Main Body: Content -->
  <div class="main px-xl-5 px-lg-4 px-3">

    <!-- Body -->
    <div class="main-body">

      <!-- Body: Header -->
      <div class="body-header border-bottom py-xl-3 py-2">
        <div class="container">

          <div class="row align-items-center">

            <!-- page title -->
            <div class="col-5 col-xl-4">
              <div class="media">
                <div class="media-body overflow-hidden">
                  <div class="d-flex align-items-center justify-content-between mb-1">
                    <h5 class="text-truncate mb-0 me-auto">Pagination</h5>
                  </div>
                  <small class="text-truncate text-muted">Get started Documentation with <a
                      href="https://getbootstrap.com/docs/4.5/getting-started/introduction/"
                      target="_black">Bootstrap</a></small>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>

      <!-- Page Default -->
      <div class="body-page d-flex py-xl-3 py-2">
        <div class="container">

          <!-- Doc: Introduction -->
          <div class="row">

            <!-- Pagination: Overview -->
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Overview</h5>
              <p>We use a large block of connected links for our pagination, making links hard to miss and easily
                scalable—all while providing large hit areas. Pagination is built with list HTML elements so screen
                readers can announce the number of available links. Use a wrapping <code
                  class="text-danger">&lt;nav&gt;</code> element to identify it as a navigation section to screen
                readers
                and other assistive technologies.</p>
              <p>In addition, as pages likely have more than one such navigation section, it’s advisable to provide a
                descriptive <code class="text-danger">aria-label</code> for the <code
                  class="text-danger">&lt;nav&gt;</code> to reflect its purpose. For example, if the pagination
                component
                is used to navigate between a set of search results, an appropriate label could be <code
                  class="text-danger">aria-label="Search results pages"</code>.</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <nav aria-label="Page navigation example">
                    <ul class="pagination">
                      <li class="page-item"><a class="page-link" href="javascript:void(0);">Previous</a></li>
                      <li class="page-item"><a class="page-link" href="javascript:void(0);">1</a></li>
                      <li class="page-item"><a class="page-link" href="javascript:void(0);">2</a></li>
                      <li class="page-item"><a class="page-link" href="javascript:void(0);">3</a></li>
                      <li class="page-item"><a class="page-link" href="javascript:void(0);">Next</a></li>
                    </ul>
                  </nav>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;nav aria-label=&quot;Page navigation example&quot;&gt;
      &lt;ul class=&quot;pagination&quot;&gt;
          &lt;li class=&quot;page-item&quot;&gt;&lt;a class=&quot;page-link&quot; href=&quot;javascript:void(0);&quot;&gt;Previous&lt;/a&gt;&lt;/li&gt;
          &lt;li class=&quot;page-item&quot;&gt;&lt;a class=&quot;page-link&quot; href=&quot;javascript:void(0);&quot;&gt;1&lt;/a&gt;&lt;/li&gt;
          &lt;li class=&quot;page-item&quot;&gt;&lt;a class=&quot;page-link&quot; href=&quot;javascript:void(0);&quot;&gt;2&lt;/a&gt;&lt;/li&gt;
          &lt;li class=&quot;page-item&quot;&gt;&lt;a class=&quot;page-link&quot; href=&quot;javascript:void(0);&quot;&gt;3&lt;/a&gt;&lt;/li&gt;
          &lt;li class=&quot;page-item&quot;&gt;&lt;a class=&quot;page-link&quot; href=&quot;javascript:void(0);&quot;&gt;Next&lt;/a&gt;&lt;/li&gt;
      &lt;/ul&gt;
  &lt;/nav&gt;</code></pre>
                </div>
              </div>
            </div>

            <!-- Pagination: Working with icons -->
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Working with icons</h5>
              <p>Looking to use an icon or symbol in place of text for some pagination links? Be sure to provide proper
                screen reader support with <code class="text-danger">aria</code> attributes.</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <nav aria-label="Page navigation example">
                    <ul class="pagination">
                      <li class="page-item">
                        <a class="page-link" href="javascript:void(0);" aria-label="Previous">
                          <span aria-hidden="true">&laquo;</span>
                        </a>
                      </li>
                      <li class="page-item"><a class="page-link" href="javascript:void(0);">1</a></li>
                      <li class="page-item"><a class="page-link" href="javascript:void(0);">2</a></li>
                      <li class="page-item"><a class="page-link" href="javascript:void(0);">3</a></li>
                      <li class="page-item">
                        <a class="page-link" href="javascript:void(0);" aria-label="Next">
                          <span aria-hidden="true">&raquo;</span>
                        </a>
                      </li>
                    </ul>
                  </nav>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;ul class=&quot;pagination&quot;&gt;
      &lt;li class=&quot;page-item&quot;&gt;
          &lt;a class=&quot;page-link&quot; href=&quot;javascript:void(0);&quot; aria-label=&quot;Previous&quot;&gt;
              &lt;span aria-hidden=&quot;true&quot;&gt;&amp;laquo;&lt;/span&gt;
          &lt;/a&gt;
      &lt;/li&gt;
      &lt;li class=&quot;page-item&quot;&gt;&lt;a class=&quot;page-link&quot; href=&quot;javascript:void(0);&quot;&gt;1&lt;/a&gt;&lt;/li&gt;
      &lt;li class=&quot;page-item&quot;&gt;&lt;a class=&quot;page-link&quot; href=&quot;javascript:void(0);&quot;&gt;2&lt;/a&gt;&lt;/li&gt;
      &lt;li class=&quot;page-item&quot;&gt;&lt;a class=&quot;page-link&quot; href=&quot;javascript:void(0);&quot;&gt;3&lt;/a&gt;&lt;/li&gt;
      &lt;li class=&quot;page-item&quot;&gt;
          &lt;a class=&quot;page-link&quot; href=&quot;javascript:void(0);&quot; aria-label=&quot;Next&quot;&gt;
              &lt;span aria-hidden=&quot;true&quot;&gt;&amp;raquo;&lt;/span&gt;
          &lt;/a&gt;
      &lt;/li&gt;
  &lt;/ul&gt;</code></pre>
                </div>
              </div>
            </div>

            <!-- Pagination: Disabled and active states -->
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Disabled and active states</h5>
              <p>Pagination links are customizable for different circumstances. Use <code
                  class="text-danger">.disabled</code> for links that appear un-clickable and <code
                  class="text-danger">.active</code> to indicate the current page.</p>
              <p>While the <code class="text-danger">.disabled</code> class uses <code
                  class="text-danger">pointer-events: none</code> to <em>try</em> to disable the link functionality of
                <code class="text-danger">&lt;a&gt;</code>s, that CSS property is not yet standardized and doesn’t
                account
                for keyboard navigation. As such, you should always add <code class="text-danger">tabindex="-1"</code>
                on
                disabled links and use custom JavaScript to fully disable their functionality.
              </p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <nav aria-label="...">
                    <ul class="pagination">
                      <li class="page-item disabled">
                        <a class="page-link" href="javascript:void(0);" tabindex="-1" aria-disabled="true">Previous</a>
                      </li>
                      <li class="page-item"><a class="page-link" href="javascript:void(0);">1</a></li>
                      <li class="page-item active" aria-current="page">
                        <a class="page-link" href="javascript:void(0);">2 <span class="sr-only">(current)</span></a>
                      </li>
                      <li class="page-item"><a class="page-link" href="javascript:void(0);">3</a></li>
                      <li class="page-item">
                        <a class="page-link" href="javascript:void(0);">Next</a>
                      </li>
                    </ul>
                  </nav>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;nav aria-label=&quot;...&quot;&gt;
      &lt;ul class=&quot;pagination&quot;&gt;
          &lt;li class=&quot;page-item disabled&quot;&gt;
              &lt;a class=&quot;page-link&quot; href=&quot;javascript:void(0);&quot; tabindex=&quot;-1&quot; aria-disabled=&quot;true&quot;&gt;Previous&lt;/a&gt;
          &lt;/li&gt;
          &lt;li class=&quot;page-item&quot;&gt;&lt;a class=&quot;page-link&quot; href=&quot;javascript:void(0);&quot;&gt;1&lt;/a&gt;&lt;/li&gt;
          &lt;li class=&quot;page-item active&quot; aria-current=&quot;page&quot;&gt;
              &lt;a class=&quot;page-link&quot; href=&quot;javascript:void(0);&quot;&gt;2 &lt;span class=&quot;sr-only&quot;&gt;(current)&lt;/span&gt;&lt;/a&gt;
          &lt;/li&gt;
          &lt;li class=&quot;page-item&quot;&gt;&lt;a class=&quot;page-link&quot; href=&quot;javascript:void(0);&quot;&gt;3&lt;/a&gt;&lt;/li&gt;
          &lt;li class=&quot;page-item&quot;&gt;
              &lt;a class=&quot;page-link&quot; href=&quot;javascript:void(0);&quot;&gt;Next&lt;/a&gt;
          &lt;/li&gt;
      &lt;/ul&gt;
  &lt;/nav&gt;</code></pre>
                </div>
              </div>
            </div>

            <!-- Pagination: Sizing -->
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Sizing</h5>
              <p>Fancy larger or smaller pagination? Add <code class="text-danger">.pagination-lg</code> or <code
                  class="text-danger">.pagination-sm</code> for additional sizes.</p>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <nav aria-label="...">
                    <ul class="pagination pagination-sm">
                      <li class="page-item active" aria-current="page">
                        <span class="page-link">1 <span class="sr-only">(current)</span></span>
                      </li>
                      <li class="page-item"><a class="page-link" href="javascript:void(0);">2</a></li>
                      <li class="page-item"><a class="page-link" href="javascript:void(0);">3</a></li>
                    </ul>
                  </nav>

                  <nav aria-label="...">
                    <ul class="pagination pagination-lg">
                      <li class="page-item active" aria-current="page">
                        <span class="page-link">1<span class="sr-only">(current)</span></span>
                      </li>
                      <li class="page-item"><a class="page-link" href="javascript:void(0);">2</a></li>
                      <li class="page-item"><a class="page-link" href="javascript:void(0);">3</a></li>
                    </ul>
                  </nav>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;nav aria-label=&quot;...&quot;&gt;
      &lt;ul class=&quot;pagination pagination-sm&quot;&gt;
          &lt;li class=&quot;page-item active&quot; aria-current=&quot;page&quot;&gt;
              &lt;span class=&quot;page-link&quot;&gt;1 &lt;span class=&quot;sr-only&quot;&gt;(current)&lt;/span&gt;&lt;/span&gt;
          &lt;/li&gt;
          &lt;li class=&quot;page-item&quot;&gt;&lt;a class=&quot;page-link&quot; href=&quot;javascript:void(0);&quot;&gt;2&lt;/a&gt;&lt;/li&gt;
          &lt;li class=&quot;page-item&quot;&gt;&lt;a class=&quot;page-link&quot; href=&quot;javascript:void(0);&quot;&gt;3&lt;/a&gt;&lt;/li&gt;
      &lt;/ul&gt;
  &lt;/nav&gt;

  &lt;nav aria-label=&quot;...&quot;&gt;
      &lt;ul class=&quot;pagination pagination-lg&quot;&gt;
          &lt;li class=&quot;page-item active&quot; aria-current=&quot;page&quot;&gt;
              &lt;span class=&quot;page-link&quot;&gt;1&lt;span class=&quot;sr-only&quot;&gt;(current)&lt;/span&gt;&lt;/span&gt;
          &lt;/li&gt;
          &lt;li class=&quot;page-item&quot;&gt;&lt;a class=&quot;page-link&quot; href=&quot;javascript:void(0);&quot;&gt;2&lt;/a&gt;&lt;/li&gt;
          &lt;li class=&quot;page-item&quot;&gt;&lt;a class=&quot;page-link&quot; href=&quot;javascript:void(0);&quot;&gt;3&lt;/a&gt;&lt;/li&gt;
      &lt;/ul&gt;
  &lt;/nav&gt;</code></pre>
                </div>
              </div>
            </div>

            <!-- Pagination: Alignment -->
            <div class="col-lg-12">
              <h5 class="card-title mb-1">Alignment</h5>
              <p>Change the alignment of pagination components with <a
                  href="https://getbootstrap.com/docs/4.5/utilities/flex/">flexbox utilities</a>.</p>
              <div class="card mb-2 shadow-sm">
                <div class="card-body">
                  <nav aria-label="Page navigation example">
                    <ul class="pagination justify-content-center">
                      <li class="page-item disabled">
                        <a class="page-link" href="javascript:void(0);" tabindex="-1" aria-disabled="true">Previous</a>
                      </li>
                      <li class="page-item"><a class="page-link" href="javascript:void(0);">1</a></li>
                      <li class="page-item"><a class="page-link" href="javascript:void(0);">2</a></li>
                      <li class="page-item"><a class="page-link" href="javascript:void(0);">3</a></li>
                      <li class="page-item">
                        <a class="page-link" href="javascript:void(0);">Next</a>
                      </li>
                    </ul>
                  </nav>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;nav aria-label=&quot;Page navigation example&quot;&gt;
      &lt;ul class=&quot;pagination justify-content-center&quot;&gt;
          &lt;li class=&quot;page-item disabled&quot;&gt;
              &lt;a class=&quot;page-link&quot; href=&quot;javascript:void(0);&quot; tabindex=&quot;-1&quot; aria-disabled=&quot;true&quot;&gt;Previous&lt;/a&gt;
          &lt;/li&gt;
          &lt;li class=&quot;page-item&quot;&gt;&lt;a class=&quot;page-link&quot; href=&quot;javascript:void(0);&quot;&gt;1&lt;/a&gt;&lt;/li&gt;
          &lt;li class=&quot;page-item&quot;&gt;&lt;a class=&quot;page-link&quot; href=&quot;javascript:void(0);&quot;&gt;2&lt;/a&gt;&lt;/li&gt;
          &lt;li class=&quot;page-item&quot;&gt;&lt;a class=&quot;page-link&quot; href=&quot;javascript:void(0);&quot;&gt;3&lt;/a&gt;&lt;/li&gt;
          &lt;li class=&quot;page-item&quot;&gt;
              &lt;a class=&quot;page-link&quot; href=&quot;javascript:void(0);&quot;&gt;Next&lt;/a&gt;
          &lt;/li&gt;
      &lt;/ul&gt;
  &lt;/nav&gt;</code></pre>
                </div>
              </div>
              <div class="card mb-5 shadow-sm">
                <div class="card-body">
                  <nav aria-label="Page navigation example">
                    <nav aria-label="Page navigation example">
                      <ul class="pagination justify-content-end">
                        <li class="page-item disabled">
                          <a class="page-link" href="javascript:void(0);" tabindex="-1"
                            aria-disabled="true">Previous</a>
                        </li>
                        <li class="page-item"><a class="page-link" href="javascript:void(0);">1</a></li>
                        <li class="page-item"><a class="page-link" href="javascript:void(0);">2</a></li>
                        <li class="page-item"><a class="page-link" href="javascript:void(0);">3</a></li>
                        <li class="page-item">
                          <a class="page-link" href="javascript:void(0);">Next</a>
                        </li>
                      </ul>
                    </nav>
                  </nav>
                </div>
                <div class="card-footer">
                  <pre><code class="language-html">&lt;nav aria-label=&quot;Page navigation example&quot;&gt;
      &lt;ul class=&quot;pagination justify-content-end&quot;&gt;
          &lt;li class=&quot;page-item disabled&quot;&gt;
              &lt;a class=&quot;page-link&quot; href=&quot;javascript:void(0);&quot; tabindex=&quot;-1&quot; aria-disabled=&quot;true&quot;&gt;Previous&lt;/a&gt;
          &lt;/li&gt;
          &lt;li class=&quot;page-item&quot;&gt;&lt;a class=&quot;page-link&quot; href=&quot;javascript:void(0);&quot;&gt;1&lt;/a&gt;&lt;/li&gt;
          &lt;li class=&quot;page-item&quot;&gt;&lt;a class=&quot;page-link&quot; href=&quot;javascript:void(0);&quot;&gt;2&lt;/a&gt;&lt;/li&gt;
          &lt;li class=&quot;page-item&quot;&gt;&lt;a class=&quot;page-link&quot; href=&quot;javascript:void(0);&quot;&gt;3&lt;/a&gt;&lt;/li&gt;
          &lt;li class=&quot;page-item&quot;&gt;
              &lt;a class=&quot;page-link&quot; href=&quot;javascript:void(0);&quot;&gt;Next&lt;/a&gt;
          &lt;/li&gt;
      &lt;/ul&gt;
  &lt;/nav&gt;</code></pre>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>
      <!-- End Page Default -->

    </div>
    <!-- End chat body -->

  </div>
  <!-- Main Body: Content -->
</div>
